export default __webpack_public_path__ + "static/media/icon-arrow-down.b868622c.svg";